import { useState } from 'react';
import './App.css';

function App() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    mensaje: ''
  });
  const [formStatus, setFormStatus] = useState({
    loading: false,
    success: false,
    error: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus({ loading: true, success: false, error: '' });

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setFormStatus({ loading: false, success: true, error: '' });
        setFormData({ nombre: '', email: '', mensaje: '' });
      } else {
        setFormStatus({
          loading: false,
          success: false,
          error: data.message || 'Error al enviar el mensaje'
        });
      }
    } catch (error) {
      setFormStatus({
        loading: false,
        success: false,
        error: 'Error de conexión. Por favor intenta de nuevo.'
      });
    }
  };

  return (
    <div className="App">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo">
            <span className="logo-icon">{'<>'}</span>
            <span className="logo-text">Code Colombia</span>
          </div>
          <div className="nav-links">
            <a href="#inicio">Inicio</a>
            <a href="#servicios">Servicios</a>
            <a href="#contacto">Contacto</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="inicio" className="hero">
        <div className="hero-background">
          <div className="grid-overlay"></div>
          <div className="gradient-orb orb-1"></div>
          <div className="gradient-orb orb-2"></div>
          <div className="gradient-orb orb-3"></div>
        </div>

        <div className="hero-content">
          <div className="hero-badge">🚀 Innovación Tecnológica</div>
          <h1 className="hero-title">
               Transformación 
             <span className="gradient-text">Digital</span>
          </h1>
          <p className="hero-subtitle">
            Ingeniería de software de alto nivel. Construimos la infraestructura tecnológica
            que impulsa a las empresas más exigentes de Colombia.
          </p>
          <div className="hero-buttons">
            <a href="#contacto" className="btn btn-primary">
              <span>Comenzar Proyecto</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
            <a href="#servicios" className="btn btn-secondary">
              <span>Ver Servicios</span>
            </a>
          </div>


        </div>
      </section>

      {/* Servicios Section */}
      <section id="servicios" className="services">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Servicios</span>
            <h2 className="section-title">Lo Que Ofrecemos</h2>
            <p className="section-subtitle">
              Soluciones tecnológicas integrales para llevar tu negocio al futuro digital
            </p>
          </div>

          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <rect x="5" y="28" width="6" height="10" rx="1" stroke="currentColor" strokeWidth="2" />
                  <rect x="13" y="20" width="6" height="18" rx="1" stroke="currentColor" strokeWidth="2" />
                  <rect x="21" y="15" width="6" height="23" rx="1" stroke="currentColor" strokeWidth="2" />
                  <rect x="29" y="10" width="6" height="28" rx="1" stroke="currentColor" strokeWidth="2" />
                  <path d="M8 24L16 16L24 12L32 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <circle cx="8" cy="24" r="2" fill="currentColor" />
                  <circle cx="16" cy="16" r="2" fill="currentColor" />
                  <circle cx="24" cy="12" r="2" fill="currentColor" />
                  <circle cx="32" cy="7" r="2" fill="currentColor" />
                </svg>
              </div>
              <h3 className="service-title">Analytics & BI</h3>
              <p className="service-description">
                Dashboards interactivos, análisis de datos en tiempo real y visualizaciones para toma de decisiones informadas
              </p>
              <ul className="service-features">
                <li>Business Intelligence</li>
                <li>Data Visualization</li>
                <li>Reportes Personalizados</li>
              </ul>
            </div>

            <div className="service-card featured">
              <div className="service-icon">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <circle cx="20" cy="20" r="15" stroke="currentColor" strokeWidth="2" />
                  <circle cx="20" cy="20" r="3" fill="currentColor" />
                  <path d="M20 5V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <path d="M20 32V35" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <path d="M35 20H32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <path d="M8 20H5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <path d="M30.6 9.4L28.5 11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <path d="M11.5 28.5L9.4 30.6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <path d="M30.6 30.6L28.5 28.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <path d="M11.5 11.5L9.4 9.4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <circle cx="20" cy="12" r="1.5" fill="currentColor" />
                  <circle cx="20" cy="28" r="1.5" fill="currentColor" />
                  <circle cx="28" cy="20" r="1.5" fill="currentColor" />
                  <circle cx="12" cy="20" r="1.5" fill="currentColor" />
                </svg>
              </div>
              <h3 className="service-title">Inteligencia Artificial</h3>
              <p className="service-description">
                Modelos de IA personalizados, machine learning y automatización inteligente para optimizar tu negocio
              </p>
              <ul className="service-features">
                <li>Machine Learning</li>
                <li>Computer Vision</li>
                <li>NLP & Chatbots</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <rect x="8" y="8" width="24" height="24" rx="2" stroke="currentColor" strokeWidth="2" />
                  <path d="M8 16H32" stroke="currentColor" strokeWidth="2" />
                  <path d="M16 8V32" stroke="currentColor" strokeWidth="2" />
                  <circle cx="12" cy="12" r="1.5" fill="currentColor" />
                </svg>
              </div>
              <h3 className="service-title">Sistemas Empresariales</h3>
              <p className="service-description">
                Soluciones a medida para gestión, inventarios, CRM y automatización de procesos
              </p>
              <ul className="service-features">
                <li>ERP & CRM</li>
                <li>APIs & Microservicios</li>
                <li>Integraciones</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <path d="M20 5L35 12.5V27.5L20 35L5 27.5V12.5L20 5Z" stroke="currentColor" strokeWidth="2" />
                  <path d="M20 5V35" stroke="currentColor" strokeWidth="2" />
                  <path d="M5 12.5L35 27.5" stroke="currentColor" strokeWidth="2" />
                  <path d="M35 12.5L5 27.5" stroke="currentColor" strokeWidth="2" />
                </svg>
              </div>
              <h3 className="service-title">Cloud & DevOps</h3>
              <p className="service-description">
                Infraestructura en la nube, CI/CD y optimización de despliegues
              </p>
              <ul className="service-features">
                <li>AWS / Azure / GCP</li>
                <li>Docker & Kubernetes</li>
                <li>Automatización</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <circle cx="20" cy="20" r="12" stroke="currentColor" strokeWidth="2" />
                  <path d="M20 8V20L28 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </div>
              <h3 className="service-title">Consultoría Tech</h3>
              <p className="service-description">
                Asesoría en arquitectura de software, stack tecnológico y mejores prácticas
              </p>
              <ul className="service-features">
                <li>Auditoría de Código</li>
                <li>Arquitectura de Software</li>
                <li>Migración Tecnológica</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <rect x="8" y="12" width="24" height="20" rx="2" stroke="currentColor" strokeWidth="2" />
                  <path d="M14 12V8C14 6.89543 14.8954 6 16 6H24C25.1046 6 26 6.89543 26 8V12" stroke="currentColor" strokeWidth="2" />
                  <circle cx="20" cy="22" r="3" stroke="currentColor" strokeWidth="2" />
                </svg>
              </div>
              <h3 className="service-title">Seguridad & Testing</h3>
              <p className="service-description">
                Análisis de vulnerabilidades, testing automatizado y aseguramiento de calidad
              </p>
              <ul className="service-features">
                <li>Penetration Testing</li>
                <li>QA Automatizado</li>
                <li>Code Security</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Contacto Section */}
      <section id="contacto" className="contact">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info">
              <h2 className="contact-title">¿Listo para Iniciar?</h2>
              <p className="contact-description">
                Nos encantaría trabajar contigo. Contáctanos para discutir tu próximo proyecto y cómo podemos apoyarte.
              </p>

              <div className="contact-methods">
                <div className="contact-method">
                  <div className="method-icon">📧</div>
                  <div className="method-content">
                    <h4>Email</h4>
                    <a href="mailto:info@codecolombia.com">admin@codecolombia.com</a>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="method-icon">📍</div>
                  <div className="method-content">
                    <h4>Ubicación</h4>
                    <p>Bogotá, Colombia</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-form-wrapper">
              <form className="contact-form" onSubmit={handleSubmit}>
                {formStatus.success && (
                  <div className="form-message form-success">
                    Mensaje enviado exitosamente. Nos pondremos en contacto pronto.
                  </div>
                )}
                {formStatus.error && (
                  <div className="form-message form-error">
                    {formStatus.error}
                  </div>
                )}

                <div className="form-group">
                  <label>Nombre</label>
                  <input
                    type="text"
                    name="nombre"
                    placeholder="Tu nombre"
                    value={formData.nombre}
                    onChange={handleInputChange}
                    required
                    disabled={formStatus.loading}
                  />
                </div>

                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="tu@email.com"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    disabled={formStatus.loading}
                  />
                </div>

                <div className="form-group">
                  <label>Mensaje</label>
                  <textarea
                    name="mensaje"
                    placeholder="Cuéntanos sobre tu proyecto..."
                    rows="5"
                    value={formData.mensaje}
                    onChange={handleInputChange}
                    required
                    disabled={formStatus.loading}
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary btn-full"
                  disabled={formStatus.loading}
                >
                  <span>{formStatus.loading ? 'Enviando...' : 'Enviar Mensaje'}</span>
                  {!formStatus.loading && (
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">


          <div className="footer-bottom">
            <p>&copy; Code Colombia</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;